export const DASHBOARD_PANEL_RECENT_ALERTS = "DASHBOARD_PANEL_RECENT_ALERTS";
export const DASHBOARD_PANEL_RECENT_ALERTS_RESPONSE = "DASHBOARD_PANEL_RECENT_ALERTS_RESPONSE";